'use strict';

/**
 * Updates the label of the given input to the correct position based on whether or not it has a value set.
 * @param {jQuery} $input - jQuery element representing the input field
 */
function updateLabel($input) {
    var $parent = $input.closest('.form-group');

    if (!($input.val() && $input.val().length) && !$input.is('select')) {
        $parent.removeClass('has-focus');
        $parent.removeClass('is-valid');
        $input.prev('.form-control-label').removeClass('prepopulated');
    } else {
        $input.prev('.form-control-label').removeClass('prepopulated');
        $parent.addClass('is-valid');
    }
}

module.exports = {
    initInputLabels: function () {
        var $inputs = $('.form-control');

        $inputs.each(function (index, input) {
            var $input = $(input);
            if ($input.val() && $input.val().length > 0) {
                $input.prev('.form-control-label').addClass('prepopulated');
                $input.parent().addClass('is-valid');
                $input.parent().addClass('has-focus');
            }
        });

        $inputs.trigger('blur.input');
    },

    initInputEvents: function () {
        $('body').on('focus.input', '.form-control', function () {
            var $this = $(this);
            var $parent = $this.closest('.form-group');

            $parent.addClass('has-focus');
        });

        $('body').on('blur.input', '.form-control', function () {
            updateLabel($(this));
        });

        $('.form-control').trigger('blur.input');
    },

    initPasswordOptions: function () {
        $(document).off('click', '.show-password-option').on('click', '.show-password-option', function () {
            var $this = $(this);
            var $passwordField = $this.siblings('.password-field');

            if ($passwordField.length) {
                if ($passwordField.attr('type') === 'password') {
                    $passwordField.attr('type', 'text');
                    $this.addClass('hide-password-icon');
                    $this.removeClass('show-password-icon');
                } else {
                    $passwordField.attr('type', 'password');
                    $this.addClass('show-password-icon');
                    $this.removeClass('hide-password-icon');
                }
            }
        });
    },

    zipCodeValidation: function () {
        $('#shippingZipCode, #billingZipCode, #zipCode').on('keypress', function (e) {
            var regex = new RegExp('^[0-9-]{0,4}$');
            var key = String.fromCharCode(!e.charCode ? e.which : e.charCode);
            var zipCode = e && e.target && e.target.value;
            if (!regex.test(key) || (regex.test(key) && zipCode.includes('-') && (key === '-'))) {
                e.preventDefault();
                return false;
            }
            return true;
        });
    }

};
